import { render, staticRenderFns } from "./avatar-gallery.vue?vue&type=template&id=2973bab4&"
import script from "./avatar-gallery.vue?vue&type=script&lang=ts&"
export * from "./avatar-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./avatar-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports